"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_utils_1 = require("@zapier/common-utils");
const core_1 = require("@emotion/core");
const design_system_1 = require("@zapier/design-system");
const containerCss = core_1.css `
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
`;
const iconContainerCss = core_1.css `
  margin-bottom: 10px;
  padding: 5px;
  border-radius: 10px;
  border: 1px solid ${design_system_1.Colors.grey200};
  background-color: ${design_system_1.Colors.white};
`;
const buttonCss = core_1.css `
  color: ${design_system_1.Colors.blue500};
`;
function EmptySearchResults({ query, onNoAppFound }) {
    return (common_utils_1.isolateComponent("div", { css: containerCss },
        common_utils_1.isolateComponent("div", { css: iconContainerCss },
            common_utils_1.isolateComponent(design_system_1.Icon, { color: "grey300", isBlock: true, name: "navHelp", size: 30 })),
        common_utils_1.isolateComponent("div", null,
            common_utils_1.isolateComponent(design_system_1.Text, { type: "bodyText800" },
                "No results for",
                ' ',
                common_utils_1.isolateComponent(design_system_1.Text, { fontWeight: 600, type: "bodyText800" }, query))),
        common_utils_1.isolateComponent("button", { css: buttonCss, onClick: onNoAppFound }, "Can't find the app you need?")));
}
exports.default = EmptySearchResults;
